// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppPage-module__content--ULmIm {
  width: 100%;
  overflow: hidden;
}

.AppPage-module__bannerBox--N4q5P {
  width: 100%;
  background-color: #f5f6f6;
}

.AppPage-module__bannerContent--VaJH4 {
  width: 100%;
  max-width: 900px;
  min-height: 450px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f6f6;
  box-sizing: border-box;
}

.AppPage-module__descriptionBox--WMEDU {
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
}

.AppPage-module__descriptionBox--WMEDU h1 {
  color: #0054e6;
  font-size: 40px;
  line-height: 1.2;
  margin: 10px 0;
}

.AppPage-module__description--lGptj {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.AppPage-module__description--lGptj p {
  color: #767680;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 500;
  margin: 0;
}

.AppPage-module__btnBox--ZMy1f {
  margin-top: 40px;
}

.AppPage-module__imgBox--LLe2q {
  width: 50%;
  display: flex;
  justify-content: center;
  align-self: flex-end;
  flex-shrink: 0;
}

.AppPage-module__imgBox--LLe2q picture {
  display: block;
}

.AppPage-module__imgBox--LLe2q img {
  display: block;
  width: auto;
  height: auto;
  max-width: none;
  max-height: 450px;
}

.AppPage-module__anchorNavigation--uehP4 {
  width: 100%;
  max-width: 900px;
  margin: 30px auto;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.AppPage-module__anchorNavigation--uehP4 button {
  border: none;
  background-color: #f5f6f8;
  color: #17181c;
  font-family: inherit;
  font-size: 16px;
  line-height: 1;
  padding: 14px 25px;
  border-radius: 14px;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background-color 0.2s ease,
    transform 0.2s ease;
}

.AppPage-module__anchorNavigation--uehP4 button:hover {
  background-color: #e9ebef;
  transform: translateY(-1px);
}

.AppPage-module__anchorNavigation--uehP4 button:active {
  transform: translateY(0);
}

.AppPage-module__anchorNavigation--uehP4 .AppPage-module__downloadAnchor--ExfP8 {
  background-color: #0054e6;
  color: #ffffff;
}

.AppPage-module__anchorNavigation--uehP4 .AppPage-module__downloadAnchor--ExfP8:hover {
  background-color: #0048c9;
}

.AppPage-module__sections--STBaT {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 0 20px 80px;
  box-sizing: border-box;
}

.AppPage-module__appSection--UIFg2 {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px 25px;
  box-sizing: border-box;
  background-color: #f5f6f6;
  border-radius: 14px;
  display: flex;
  align-items: center;
  gap: 60px;
  scroll-margin-top: 30px;
}

.AppPage-module__appSection--UIFg2.AppPage-module__reverse--zqbZH {
  flex-direction: row-reverse;
}
.AppPage-module__reverse--zqbZH > .AppPage-module__sectionImage--qd14g {
  justify-content: flex-end;
}

.AppPage-module__sectionImage--qd14g {
  width: 40%;
  display: flex;
  flex-shrink: 0;
}

.AppPage-module__sectionImage--qd14g img {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
}

.AppPage-module__sectionText--WQCPt {
  flex: 1;
  padding: 0 10px;
}

.AppPage-module__sectionText--WQCPt h2 {
  margin: 0 0 10px;
  color: #0054e6;
  font-size: 30px;
  line-height: 1.12;
  font-weight: 600;
}

.AppPage-module__sectionText--WQCPt p {
  margin: 0;
  color: #767680;
  font-size: 16px;
  line-height: 1.55;
}

.AppPage-module__downloadSection--UadwC {
  width: 100%;
  max-width: 900px;
  margin: 0px auto 0;
  box-sizing: border-box;
  border-radius: 14px;
  background-color: #f5f6f6;
  scroll-margin-top: 30px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  padding: 0 25px;
}

.AppPage-module__downloadContent--J5ZKx {
  display: flex;
  flex-direction: column;
}

.AppPage-module__downloadSection--UadwC h2 {
  margin: 0 0 10px;
  color: #0054e6;
  font-size: 30px;
  line-height: 1.15;
}

.AppPage-module__downloadSection--UadwC p {
  margin: 0;
  color: #767680;
  font-size: 16px;
  line-height: 1.5;
}

.AppPage-module__storeButtons--E1u7T {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
  margin-top: 40px;
}

.AppPage-module__storeButton--DZiPx {
  display: flex;
  align-items: center;
  justify-content: center;
}

.AppPage-module__storeButton--DZiPx > img {
  width: 80px;
  height: 70px;
  max-width: none;
  max-height: none;
}

.AppPage-module__storeButton--DZiPx:hover {
  transform: translateY(-2px);
}

.AppPage-module__scrollTopButton--dykUH {
  position: fixed;
  right: 25px;
  bottom: 25px;
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background-color: #0054e6;
  color: #ffffff;
  font-size: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  transition:
    transform 0.2s ease,
    background-color 0.2s ease;
}

.AppPage-module__scrollTopButton--dykUH:hover {
  background-color: #0048c9;
  transform: translateY(-2px);
}

.AppPage-module__storeModal--GXHlh {
  width: 100%;
  max-width: 420px;
  margin: 20px;
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.AppPage-module__storeModalContent--_xV2g {
  position: relative;
  padding: 35px 30px 30px;
  box-sizing: border-box;
  text-align: center;
  background-color: #ffffff;
}

.AppPage-module__storeModalContent--_xV2g h2 {
  margin: 0 35px 10px;
  color: #0054e6;
  font-size: 26px;
  line-height: 1.2;
  font-weight: 600;
}

.AppPage-module__storeModalContent--_xV2g p {
  margin: 0 auto 30px;
  max-width: 320px;
  color: #767680;
  font-size: 15px;
  line-height: 1.5;
}

.AppPage-module__storeModalClose--HlI8x {
  position: absolute;
  top: 12px;
  right: 14px;

  width: 36px;
  height: 36px;

  padding: 0;
  border: none;
  border-radius: 50%;

  background-color: #f5f6f8;
  color: #767680;

  font-family: inherit;
  font-size: 26px;
  line-height: 36px;

  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}

.AppPage-module__storeModalClose--HlI8x:hover {
  background-color: #e9ebef;
  color: #17181c;
  transform: scale(1.05);
}

.AppPage-module__storeModalClose--HlI8x:active {
  transform: scale(0.95);
}

.AppPage-module__storeModalLinks--h2DRp {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.AppPage-module__downloadImageText--LEbxN {
  position: absolute;
  bottom: 35px;
  width: 160px;
  font-size: 10px;
  font-weight: 600;
  color: #767680;
  left: 53px;
  text-align: center;
}
.AppPage-module__downloadImage--AZakM {
  position: relative;
}

@media (max-width: 850px) {
  .AppPage-module__bannerContent--VaJH4 {
    min-height: 0;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    max-width: 100%;
    padding: 30px 20px 0;
  }

  .AppPage-module__descriptionBox--WMEDU {
    width: 100%;
    max-width: 600px;
    align-items: center;
    text-align: center;
  }

  .AppPage-module__descriptionBox--WMEDU h1 {
    font-size: 32px;
  }

  .AppPage-module__btnBox--ZMy1f {
    margin-top: 20px;
  }

  .AppPage-module__imgBox--LLe2q {
    width: 100%;
    justify-content: center;
    align-self: auto;
    margin-top: 20px;
  }

  .AppPage-module__imgBox--LLe2q img {
    width: auto;
    height: auto;
    max-width: none;
    max-height: none;
  }
  .AppPage-module__anchorNavigation--uehP4 {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 10px;
    padding: 0 20px 5px;
    margin: 30px auto;
    box-sizing: border-box;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .AppPage-module__anchorNavigation--uehP4::-webkit-scrollbar {
    display: none;
  }

  .AppPage-module__anchorNavigation--uehP4 button {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  .AppPage-module__sections--STBaT {
    gap: 25px;
    padding: 0 15px 0px;
  }

  .AppPage-module__appSection--UIFg2,
  .AppPage-module__appSection--UIFg2.AppPage-module__reverse--zqbZH {
    min-height: 0;
    padding: 35px 25px;
    flex-direction: column;
    gap: 30px;
    border-radius: 14px;
  }

  .AppPage-module__sectionImage--qd14g {
    width: 40%;
    align-items: center;
    justify-content: center;
  }

  .AppPage-module__sectionImage--qd14g img {
    max-height: 280px;
  }

  .AppPage-module__sectionText--WQCPt {
    width: 100%;
    text-align: center;
  }

  .AppPage-module__sectionText--WQCPt h2 {
    font-size: 30px;
    margin-bottom: 15px;
  }

  .AppPage-module__sectionText--WQCPt p {
    font-size: 16px;
  }

  .AppPage-module__downloadContent--J5ZKx {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }
  .AppPage-module__downloadImage--AZakM > img {
    margin-right: 25px;
  }
}

@media (max-width: 600px) {
  .AppPage-module__descriptionBox--WMEDU h1 {
    font-size: 28px;
  }
  .AppPage-module__description--lGptj p {
    font-size: 14px;
  }

  .AppPage-module__anchorNavigation--uehP4 {
    gap: 8px;
  }

  .AppPage-module__anchorNavigation--uehP4 button {
    font-size: 14px;
    padding: 12px 18px;
  }

  .AppPage-module__appSection--UIFg2 {
    padding: 30px 20px;
  }

  .AppPage-module__sectionImage--qd14g img {
    max-height: 220px;
  }

  .AppPage-module__sectionText--WQCPt h2 {
    font-size: 26px;
  }

  .AppPage-module__sectionText--WQCPt p {
    font-size: 15px;
  }

  .AppPage-module__downloadSection--UadwC {
    flex-direction: column;
    padding: 35px 25px 0;
  }
  .AppPage-module__downloadSection--UadwC h2 {
    font-size: 28px;
  }

  .AppPage-module__downloadSection--UadwC p {
    font-size: 15px;
  }

  .AppPage-module__storeButtons--E1u7T {
    width: 100%;
    flex-direction: row;
    margin-top: 0;
    justify-content: center;
    flex-wrap: wrap;
    display: flex;
  }

  .AppPage-module__storeButton--DZiPx {
    box-sizing: border-box;
  }

  .AppPage-module__scrollTopButton--dykUH {
    right: 15px;
    bottom: 15px;
    width: 45px;
    height: 45px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/app-page/AppPage.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB;;uBAEqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,0CAA0C;EAC1C;;8BAE4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;;EAEX,WAAW;EACX,YAAY;;EAEZ,UAAU;EACV,YAAY;EACZ,kBAAkB;;EAElB,yBAAyB;EACzB,cAAc;;EAEd,oBAAoB;EACpB,eAAe;EACf,iBAAiB;;EAEjB,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB;;;uBAGqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".content {\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.bannerBox {\r\n  width: 100%;\r\n  background-color: #f5f6f6;\r\n}\r\n\r\n.bannerContent {\r\n  width: 100%;\r\n  max-width: 900px;\r\n  min-height: 450px;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #f5f6f6;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.descriptionBox {\r\n  width: 40%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.descriptionBox h1 {\r\n  color: #0054e6;\r\n  font-size: 40px;\r\n  line-height: 1.2;\r\n  margin: 10px 0;\r\n}\r\n\r\n.description {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.description p {\r\n  color: #767680;\r\n  font-size: 16px;\r\n  line-height: 1.4;\r\n  font-weight: 500;\r\n  margin: 0;\r\n}\r\n\r\n.btnBox {\r\n  margin-top: 40px;\r\n}\r\n\r\n.imgBox {\r\n  width: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-self: flex-end;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.imgBox picture {\r\n  display: block;\r\n}\r\n\r\n.imgBox img {\r\n  display: block;\r\n  width: auto;\r\n  height: auto;\r\n  max-width: none;\r\n  max-height: 450px;\r\n}\r\n\r\n.anchorNavigation {\r\n  width: 100%;\r\n  max-width: 900px;\r\n  margin: 30px auto;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.anchorNavigation button {\r\n  border: none;\r\n  background-color: #f5f6f8;\r\n  color: #17181c;\r\n  font-family: inherit;\r\n  font-size: 16px;\r\n  line-height: 1;\r\n  padding: 14px 25px;\r\n  border-radius: 14px;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  transition:\r\n    background-color 0.2s ease,\r\n    transform 0.2s ease;\r\n}\r\n\r\n.anchorNavigation button:hover {\r\n  background-color: #e9ebef;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.anchorNavigation button:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.anchorNavigation .downloadAnchor {\r\n  background-color: #0054e6;\r\n  color: #ffffff;\r\n}\r\n\r\n.anchorNavigation .downloadAnchor:hover {\r\n  background-color: #0048c9;\r\n}\r\n\r\n.sections {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 40px;\r\n  padding: 0 20px 80px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.appSection {\r\n  width: 100%;\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n  padding: 20px 25px;\r\n  box-sizing: border-box;\r\n  background-color: #f5f6f6;\r\n  border-radius: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 60px;\r\n  scroll-margin-top: 30px;\r\n}\r\n\r\n.appSection.reverse {\r\n  flex-direction: row-reverse;\r\n}\r\n.reverse > .sectionImage {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.sectionImage {\r\n  width: 40%;\r\n  display: flex;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sectionImage img {\r\n  display: block;\r\n  width: auto;\r\n  height: auto;\r\n  max-width: 100%;\r\n  max-height: 200px;\r\n  object-fit: contain;\r\n}\r\n\r\n.sectionText {\r\n  flex: 1;\r\n  padding: 0 10px;\r\n}\r\n\r\n.sectionText h2 {\r\n  margin: 0 0 10px;\r\n  color: #0054e6;\r\n  font-size: 30px;\r\n  line-height: 1.12;\r\n  font-weight: 600;\r\n}\r\n\r\n.sectionText p {\r\n  margin: 0;\r\n  color: #767680;\r\n  font-size: 16px;\r\n  line-height: 1.55;\r\n}\r\n\r\n.downloadSection {\r\n  width: 100%;\r\n  max-width: 900px;\r\n  margin: 0px auto 0;\r\n  box-sizing: border-box;\r\n  border-radius: 14px;\r\n  background-color: #f5f6f6;\r\n  scroll-margin-top: 30px;\r\n  display: flex;\r\n  align-content: center;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0 25px;\r\n}\r\n\r\n.downloadContent {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.downloadSection h2 {\r\n  margin: 0 0 10px;\r\n  color: #0054e6;\r\n  font-size: 30px;\r\n  line-height: 1.15;\r\n}\r\n\r\n.downloadSection p {\r\n  margin: 0;\r\n  color: #767680;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.storeButtons {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-shrink: 0;\r\n  margin-top: 40px;\r\n}\r\n\r\n.storeButton {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.storeButton > img {\r\n  width: 80px;\r\n  height: 70px;\r\n  max-width: none;\r\n  max-height: none;\r\n}\r\n\r\n.storeButton:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.scrollTopButton {\r\n  position: fixed;\r\n  right: 25px;\r\n  bottom: 25px;\r\n  width: 50px;\r\n  height: 50px;\r\n  border: none;\r\n  border-radius: 50%;\r\n  background-color: #0054e6;\r\n  color: #ffffff;\r\n  font-size: 25px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  z-index: 100;\r\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);\r\n  transition:\r\n    transform 0.2s ease,\r\n    background-color 0.2s ease;\r\n}\r\n\r\n.scrollTopButton:hover {\r\n  background-color: #0048c9;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.storeModal {\r\n  width: 100%;\r\n  max-width: 420px;\r\n  margin: 20px;\r\n  border-radius: 20px !important;\r\n  overflow: hidden;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.storeModalContent {\r\n  position: relative;\r\n  padding: 35px 30px 30px;\r\n  box-sizing: border-box;\r\n  text-align: center;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.storeModalContent h2 {\r\n  margin: 0 35px 10px;\r\n  color: #0054e6;\r\n  font-size: 26px;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n}\r\n\r\n.storeModalContent p {\r\n  margin: 0 auto 30px;\r\n  max-width: 320px;\r\n  color: #767680;\r\n  font-size: 15px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.storeModalClose {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 14px;\r\n\r\n  width: 36px;\r\n  height: 36px;\r\n\r\n  padding: 0;\r\n  border: none;\r\n  border-radius: 50%;\r\n\r\n  background-color: #f5f6f8;\r\n  color: #767680;\r\n\r\n  font-family: inherit;\r\n  font-size: 26px;\r\n  line-height: 36px;\r\n\r\n  cursor: pointer;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  transition:\r\n    background-color 0.2s ease,\r\n    color 0.2s ease,\r\n    transform 0.2s ease;\r\n}\r\n\r\n.storeModalClose:hover {\r\n  background-color: #e9ebef;\r\n  color: #17181c;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.storeModalClose:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n.storeModalLinks {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-content: center;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.downloadImageText {\r\n  position: absolute;\r\n  bottom: 35px;\r\n  width: 160px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  color: #767680;\r\n  left: 53px;\r\n  text-align: center;\r\n}\r\n.downloadImage {\r\n  position: relative;\r\n}\r\n\r\n@media (max-width: 850px) {\r\n  .bannerContent {\r\n    min-height: 0;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    max-width: 100%;\r\n    padding: 30px 20px 0;\r\n  }\r\n\r\n  .descriptionBox {\r\n    width: 100%;\r\n    max-width: 600px;\r\n    align-items: center;\r\n    text-align: center;\r\n  }\r\n\r\n  .descriptionBox h1 {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .btnBox {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .imgBox {\r\n    width: 100%;\r\n    justify-content: center;\r\n    align-self: auto;\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .imgBox img {\r\n    width: auto;\r\n    height: auto;\r\n    max-width: none;\r\n    max-height: none;\r\n  }\r\n  .anchorNavigation {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n    gap: 10px;\r\n    padding: 0 20px 5px;\r\n    margin: 30px auto;\r\n    box-sizing: border-box;\r\n    scrollbar-width: none;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .anchorNavigation::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n\r\n  .anchorNavigation button {\r\n    flex: 0 0 auto;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .sections {\r\n    gap: 25px;\r\n    padding: 0 15px 0px;\r\n  }\r\n\r\n  .appSection,\r\n  .appSection.reverse {\r\n    min-height: 0;\r\n    padding: 35px 25px;\r\n    flex-direction: column;\r\n    gap: 30px;\r\n    border-radius: 14px;\r\n  }\r\n\r\n  .sectionImage {\r\n    width: 40%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .sectionImage img {\r\n    max-height: 280px;\r\n  }\r\n\r\n  .sectionText {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n\r\n  .sectionText h2 {\r\n    font-size: 30px;\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .sectionText p {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .downloadContent {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    gap: 30px;\r\n  }\r\n  .downloadImage > img {\r\n    margin-right: 25px;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .descriptionBox h1 {\r\n    font-size: 28px;\r\n  }\r\n  .description p {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .anchorNavigation {\r\n    gap: 8px;\r\n  }\r\n\r\n  .anchorNavigation button {\r\n    font-size: 14px;\r\n    padding: 12px 18px;\r\n  }\r\n\r\n  .appSection {\r\n    padding: 30px 20px;\r\n  }\r\n\r\n  .sectionImage img {\r\n    max-height: 220px;\r\n  }\r\n\r\n  .sectionText h2 {\r\n    font-size: 26px;\r\n  }\r\n\r\n  .sectionText p {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .downloadSection {\r\n    flex-direction: column;\r\n    padding: 35px 25px 0;\r\n  }\r\n  .downloadSection h2 {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .downloadSection p {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .storeButtons {\r\n    width: 100%;\r\n    flex-direction: row;\r\n    margin-top: 0;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n    display: flex;\r\n  }\r\n\r\n  .storeButton {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .scrollTopButton {\r\n    right: 15px;\r\n    bottom: 15px;\r\n    width: 45px;\r\n    height: 45px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `AppPage-module__content--ULmIm`,
	"bannerBox": `AppPage-module__bannerBox--N4q5P`,
	"bannerContent": `AppPage-module__bannerContent--VaJH4`,
	"descriptionBox": `AppPage-module__descriptionBox--WMEDU`,
	"description": `AppPage-module__description--lGptj`,
	"btnBox": `AppPage-module__btnBox--ZMy1f`,
	"imgBox": `AppPage-module__imgBox--LLe2q`,
	"anchorNavigation": `AppPage-module__anchorNavigation--uehP4`,
	"downloadAnchor": `AppPage-module__downloadAnchor--ExfP8`,
	"sections": `AppPage-module__sections--STBaT`,
	"appSection": `AppPage-module__appSection--UIFg2`,
	"reverse": `AppPage-module__reverse--zqbZH`,
	"sectionImage": `AppPage-module__sectionImage--qd14g`,
	"sectionText": `AppPage-module__sectionText--WQCPt`,
	"downloadSection": `AppPage-module__downloadSection--UadwC`,
	"downloadContent": `AppPage-module__downloadContent--J5ZKx`,
	"storeButtons": `AppPage-module__storeButtons--E1u7T`,
	"storeButton": `AppPage-module__storeButton--DZiPx`,
	"scrollTopButton": `AppPage-module__scrollTopButton--dykUH`,
	"storeModal": `AppPage-module__storeModal--GXHlh`,
	"storeModalContent": `AppPage-module__storeModalContent--_xV2g`,
	"storeModalClose": `AppPage-module__storeModalClose--HlI8x`,
	"storeModalLinks": `AppPage-module__storeModalLinks--h2DRp`,
	"downloadImageText": `AppPage-module__downloadImageText--LEbxN`,
	"downloadImage": `AppPage-module__downloadImage--AZakM`
};
export default ___CSS_LOADER_EXPORT___;
